// src/enums.ts
var RoleCode = {
  ADMIN: "ADMIN",
  HR: "HR",
  EMPLOYEE: "EMPLOYEE"
};
var ROLE_LABELS = {
  ADMIN: "Administrador",
  HR: "RH",
  EMPLOYEE: "Funcion\xE1rio"
};
var UserStatus = {
  PENDING_ACTIVATION: "PENDING_ACTIVATION",
  ACTIVE: "ACTIVE",
  BLOCKED: "BLOCKED",
  INACTIVE: "INACTIVE"
};
var USER_STATUS_LABELS = {
  PENDING_ACTIVATION: "Aguardando ativa\xE7\xE3o",
  ACTIVE: "Ativo",
  BLOCKED: "Bloqueado",
  INACTIVE: "Inativo"
};
var RequestType = {
  OVERTIME: "OVERTIME",
  REIMBURSEMENT: "REIMBURSEMENT"
};
var REQUEST_TYPE_LABELS = {
  OVERTIME: "Hora extra",
  REIMBURSEMENT: "Reembolso"
};
var RequestStatus = {
  DRAFT: "DRAFT",
  UNDER_REVIEW: "UNDER_REVIEW",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  RETURNED_FOR_CORRECTION: "RETURNED_FOR_CORRECTION",
  CANCELLED: "CANCELLED"
};
var REQUEST_STATUS_LABELS = {
  DRAFT: "Rascunho",
  UNDER_REVIEW: "Em an\xE1lise",
  APPROVED: "Aprovada",
  REJECTED: "Recusada",
  RETURNED_FOR_CORRECTION: "Devolvida para corre\xE7\xE3o",
  CANCELLED: "Cancelada"
};
var PaymentStatus = {
  UNPAID: "UNPAID",
  PAID: "PAID"
};
var PAYMENT_STATUS_LABELS = {
  UNPAID: "N\xE3o pago",
  PAID: "Pago"
};
function visiblePaymentStatus(status, paymentStatus) {
  return status === RequestStatus.APPROVED ? paymentStatus : null;
}
var PENDING_REVIEW_STATUSES = [RequestStatus.UNDER_REVIEW];
var OVERTIME_BLOCKING_STATUSES = [
  RequestStatus.UNDER_REVIEW,
  RequestStatus.RETURNED_FOR_CORRECTION,
  RequestStatus.APPROVED
];
var PaymentMethod = {
  PERSONAL_CREDIT_CARD: "PERSONAL_CREDIT_CARD",
  PERSONAL_DEBIT_CARD: "PERSONAL_DEBIT_CARD",
  PIX: "PIX",
  CASH: "CASH",
  APP_BALANCE: "APP_BALANCE",
  OTHER: "OTHER"
};
var PAYMENT_METHOD_LABELS = {
  PERSONAL_CREDIT_CARD: "Cart\xE3o de cr\xE9dito pessoal",
  PERSONAL_DEBIT_CARD: "Cart\xE3o de d\xE9bito pessoal",
  PIX: "Pix",
  CASH: "Dinheiro",
  APP_BALANCE: "Saldo em aplicativo",
  OTHER: "Outro"
};
var HolidayKind = {
  HOLIDAY: "HOLIDAY",
  DAY_OFF: "DAY_OFF"
};
var HOLIDAY_KIND_LABELS = {
  HOLIDAY: "Feriado",
  DAY_OFF: "Folga"
};
var CommentVisibility = {
  /** Visível para o funcionário e para o RH. */
  PUBLIC: "PUBLIC",
  /** Nota interna, visível apenas para RH/Admin. */
  INTERNAL: "INTERNAL"
};
var DevicePlatform = {
  IOS: "IOS",
  ANDROID: "ANDROID",
  WEB: "WEB"
};
var NotificationType = {
  USER_INVITED: "USER_INVITED",
  PASSWORD_RESET: "PASSWORD_RESET",
  REQUEST_SUBMITTED: "REQUEST_SUBMITTED",
  REQUEST_RECEIVED_HR: "REQUEST_RECEIVED_HR",
  REQUEST_APPROVED: "REQUEST_APPROVED",
  REQUEST_REJECTED: "REQUEST_REJECTED",
  REQUEST_RETURNED: "REQUEST_RETURNED",
  REQUEST_PAID: "REQUEST_PAID",
  HR_PENDING_REMINDER: "HR_PENDING_REMINDER",
  OPERATIONAL_FAILURE: "OPERATIONAL_FAILURE"
};
var NOTIFICATION_TYPE_LABELS = {
  USER_INVITED: "Convite de acesso",
  PASSWORD_RESET: "Redefini\xE7\xE3o de senha",
  REQUEST_SUBMITTED: "Solicita\xE7\xE3o recebida",
  REQUEST_RECEIVED_HR: "Nova solicita\xE7\xE3o para an\xE1lise",
  REQUEST_APPROVED: "Solicita\xE7\xE3o aprovada",
  REQUEST_REJECTED: "Solicita\xE7\xE3o recusada",
  REQUEST_RETURNED: "Solicita\xE7\xE3o devolvida para corre\xE7\xE3o",
  REQUEST_PAID: "Solicita\xE7\xE3o paga",
  HR_PENDING_REMINDER: "Lembrete de pend\xEAncias",
  OPERATIONAL_FAILURE: "Falha operacional"
};
var CONFIGURABLE_NOTIFICATION_TYPES = [
  NotificationType.REQUEST_SUBMITTED,
  NotificationType.REQUEST_RECEIVED_HR,
  NotificationType.REQUEST_APPROVED,
  NotificationType.REQUEST_REJECTED,
  NotificationType.REQUEST_RETURNED,
  NotificationType.REQUEST_PAID,
  NotificationType.HR_PENDING_REMINDER
];
var OutboxChannel = {
  EMAIL: "EMAIL",
  PUSH: "PUSH"
};
var OutboxStatus = {
  PENDING: "PENDING",
  PROCESSING: "PROCESSING",
  SENT: "SENT",
  SKIPPED: "SKIPPED",
  FAILED: "FAILED",
  DEAD: "DEAD"
};
var AttachmentScanStatus = {
  PENDING: "PENDING",
  CLEAN: "CLEAN",
  INFECTED: "INFECTED",
  NOT_SCANNED: "NOT_SCANNED"
};
var DEFAULT_TIMEZONE = "America/Sao_Paulo";
var DEFAULT_CURRENCY = "BRL";
var ALLOWED_ATTACHMENT_MIME_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/png"
];
var OUTBOX_STATUS_LABELS = {
  PENDING: "Pendente",
  PROCESSING: "Processando",
  SENT: "Enviada",
  SKIPPED: "N\xE3o enviada (desabilitado)",
  FAILED: "Falhou",
  DEAD: "Falha definitiva"
};
var OUTBOX_CHANNEL_LABELS = {
  EMAIL: "E-mail",
  PUSH: "Push"
};

// src/errors.ts
var ErrorCode = {
  VALIDATION_ERROR: "VALIDATION_ERROR",
  UNAUTHENTICATED: "UNAUTHENTICATED",
  INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
  ACCOUNT_LOCKED: "ACCOUNT_LOCKED",
  ACCOUNT_INACTIVE: "ACCOUNT_INACTIVE",
  TOKEN_EXPIRED: "TOKEN_EXPIRED",
  TOKEN_INVALID: "TOKEN_INVALID",
  SESSION_REVOKED: "SESSION_REVOKED",
  FORBIDDEN: "FORBIDDEN",
  NOT_FOUND: "NOT_FOUND",
  CONFLICT: "CONFLICT",
  EMAIL_IN_USE: "EMAIL_IN_USE",
  INVALID_TRANSITION: "INVALID_TRANSITION",
  COMMENT_REQUIRED: "COMMENT_REQUIRED",
  NOT_EDITABLE: "NOT_EDITABLE",
  SELF_REVIEW_FORBIDDEN: "SELF_REVIEW_FORBIDDEN",
  EMPLOYEE_PROFILE_REQUIRED: "EMPLOYEE_PROFILE_REQUIRED",
  OVERTIME_INVALID: "OVERTIME_INVALID",
  REIMBURSEMENT_INVALID: "REIMBURSEMENT_INVALID",
  ATTACHMENT_REQUIRED: "ATTACHMENT_REQUIRED",
  ATTACHMENT_INVALID: "ATTACHMENT_INVALID",
  ATTACHMENT_TOO_LARGE: "ATTACHMENT_TOO_LARGE",
  ATTACHMENT_LIMIT_REACHED: "ATTACHMENT_LIMIT_REACHED",
  ALREADY_PAID: "ALREADY_PAID",
  CONCURRENT_MODIFICATION: "CONCURRENT_MODIFICATION",
  RATE_LIMITED: "RATE_LIMITED",
  PAYLOAD_TOO_LARGE: "PAYLOAD_TOO_LARGE",
  INTERNAL_ERROR: "INTERNAL_ERROR"
};

// src/permissions.ts
var Permission = {
  USERS_READ: "users.read",
  USERS_MANAGE: "users.manage",
  EMPLOYEES_READ_ALL: "employees.read.all",
  EMPLOYEES_MANAGE: "employees.manage",
  SCHEDULES_MANAGE: "schedules.manage",
  CATALOG_MANAGE: "catalog.manage",
  SETTINGS_MANAGE: "settings.manage",
  /** Criar/editar/enviar/cancelar as próprias solicitações (exige cadastro de funcionário). */
  REQUESTS_CREATE_OWN: "requests.create.own",
  REQUESTS_READ_OWN: "requests.read.own",
  REQUESTS_READ_ALL: "requests.read.all",
  REQUESTS_REVIEW: "requests.review",
  REQUESTS_PAY: "requests.pay",
  /** Reabrir solicitação decidida/paga (estorno de pagamento). Exclusivo do administrador. */
  REQUESTS_REOPEN: "requests.reopen",
  REQUESTS_INTERNAL_COMMENTS: "requests.comments.internal",
  ATTACHMENTS_READ_ALL: "attachments.read.all",
  DASHBOARD_READ: "dashboard.read",
  REPORTS_EXPORT: "reports.export",
  AUDIT_READ: "audit.read",
  NOTIFICATIONS_MANAGE: "notifications.manage"
};
var ALL_PERMISSIONS = Object.values(Permission);
var PERMISSION_DESCRIPTIONS = {
  "users.read": "Consultar usu\xE1rios",
  "users.manage": "Cadastrar, editar, ativar, bloquear e desativar usu\xE1rios",
  "employees.read.all": "Consultar dados de todos os funcion\xE1rios",
  "employees.manage": "Cadastrar e editar dados de funcion\xE1rios",
  "schedules.manage": "Configurar jornadas de trabalho",
  "catalog.manage": "Gerenciar feriados, categorias, departamentos e centros de custo",
  "settings.manage": "Configurar par\xE2metros gerais do sistema",
  "requests.create.own": "Criar e enviar as pr\xF3prias solicita\xE7\xF5es",
  "requests.read.own": "Consultar as pr\xF3prias solicita\xE7\xF5es",
  "requests.read.all": "Consultar solicita\xE7\xF5es de todos os funcion\xE1rios",
  "requests.review": "Aprovar, recusar ou devolver solicita\xE7\xF5es",
  "requests.pay": "Marcar solicita\xE7\xF5es aprovadas como pagas",
  "requests.reopen": "Reabrir solicita\xE7\xF5es decididas ou pagas (estorno)",
  "requests.comments.internal": "Ler e escrever notas internas do RH",
  "attachments.read.all": "Acessar comprovantes de qualquer solicita\xE7\xE3o",
  "dashboard.read": "Visualizar dashboard financeiro e operacional",
  "reports.export": "Exportar relat\xF3rios",
  "audit.read": "Consultar auditoria",
  "notifications.manage": "Acompanhar e reprocessar notifica\xE7\xF5es"
};
var P = Permission;
var ROLE_PERMISSIONS = {
  ADMIN: [
    P.USERS_READ,
    P.USERS_MANAGE,
    P.EMPLOYEES_READ_ALL,
    P.EMPLOYEES_MANAGE,
    P.SCHEDULES_MANAGE,
    P.CATALOG_MANAGE,
    P.SETTINGS_MANAGE,
    P.REQUESTS_CREATE_OWN,
    P.REQUESTS_READ_OWN,
    P.REQUESTS_READ_ALL,
    P.REQUESTS_REVIEW,
    P.REQUESTS_PAY,
    P.REQUESTS_REOPEN,
    P.REQUESTS_INTERNAL_COMMENTS,
    P.ATTACHMENTS_READ_ALL,
    P.DASHBOARD_READ,
    P.REPORTS_EXPORT,
    P.AUDIT_READ,
    P.NOTIFICATIONS_MANAGE
  ],
  HR: [
    P.USERS_READ,
    P.EMPLOYEES_READ_ALL,
    P.REQUESTS_CREATE_OWN,
    P.REQUESTS_READ_OWN,
    P.REQUESTS_READ_ALL,
    P.REQUESTS_REVIEW,
    P.REQUESTS_PAY,
    P.REQUESTS_INTERNAL_COMMENTS,
    P.ATTACHMENTS_READ_ALL,
    P.DASHBOARD_READ,
    P.REPORTS_EXPORT,
    P.AUDIT_READ
  ],
  EMPLOYEE: [P.REQUESTS_CREATE_OWN, P.REQUESTS_READ_OWN]
};
function roleHasPermission(role, permission) {
  return ROLE_PERMISSIONS[role]?.includes(permission) ?? false;
}
function hasPermission(permissions, permission) {
  return !!permissions && permissions.includes(permission);
}

// src/domain/status-machine.ts
var RequestAction = {
  SUBMIT: "SUBMIT",
  CANCEL: "CANCEL",
  APPROVE: "APPROVE",
  REJECT: "REJECT",
  RETURN_FOR_CORRECTION: "RETURN_FOR_CORRECTION",
  MARK_PAID: "MARK_PAID",
  REOPEN: "REOPEN",
  REVERSE_PAYMENT: "REVERSE_PAYMENT"
};
var REQUEST_ACTION_LABELS = {
  SUBMIT: "Enviar",
  CANCEL: "Cancelar",
  APPROVE: "Aprovar",
  REJECT: "Recusar",
  RETURN_FOR_CORRECTION: "Devolver para corre\xE7\xE3o",
  MARK_PAID: "Marcar como paga",
  REOPEN: "Reabrir",
  REVERSE_PAYMENT: "Estornar pagamento"
};
var HISTORY_ONLY_LABELS = {
  CREATE: "Criada",
  UPDATE: "Editada",
  START_REVIEW: "Iniciar an\xE1lise"
};
function historyActionLabel(action) {
  return REQUEST_ACTION_LABELS[action] ?? HISTORY_ONLY_LABELS[action] ?? action;
}
function historyResultLabel(action, toStatus) {
  if (action === "MARK_PAID") return PAYMENT_STATUS_LABELS.PAID;
  if (action === "REVERSE_PAYMENT") return PAYMENT_STATUS_LABELS.UNPAID;
  return REQUEST_STATUS_LABELS[toStatus];
}
var S = RequestStatus;
var PS = PaymentStatus;
var TRANSITIONS = {
  SUBMIT: {
    from: [S.DRAFT, S.RETURNED_FOR_CORRECTION],
    to: S.UNDER_REVIEW,
    actor: "OWNER",
    requiresComment: false
  },
  CANCEL: {
    from: [S.DRAFT, S.UNDER_REVIEW, S.RETURNED_FOR_CORRECTION],
    to: S.CANCELLED,
    actor: "OWNER",
    requiresComment: false
  },
  APPROVE: {
    from: [S.UNDER_REVIEW],
    to: S.APPROVED,
    actor: "REVIEWER",
    requiresComment: false
  },
  REJECT: {
    from: [S.UNDER_REVIEW],
    to: S.REJECTED,
    actor: "REVIEWER",
    requiresComment: true
  },
  RETURN_FOR_CORRECTION: {
    from: [S.UNDER_REVIEW],
    to: S.RETURNED_FOR_CORRECTION,
    actor: "REVIEWER",
    requiresComment: true
  },
  MARK_PAID: {
    from: [S.APPROVED],
    to: S.APPROVED,
    requiresPayment: PS.UNPAID,
    toPayment: PS.PAID,
    actor: "PAYER",
    requiresComment: false
  },
  REOPEN: {
    from: [S.APPROVED, S.REJECTED],
    to: S.UNDER_REVIEW,
    requiresPayment: PS.UNPAID,
    actor: "ADMIN",
    requiresComment: true
  },
  REVERSE_PAYMENT: {
    from: [S.APPROVED],
    to: S.APPROVED,
    requiresPayment: PS.PAID,
    toPayment: PS.UNPAID,
    actor: "ADMIN",
    requiresComment: true
  }
};
var EDITABLE_STATUSES = [S.DRAFT, S.RETURNED_FOR_CORRECTION];
function isEditableStatus(status) {
  return EDITABLE_STATUSES.includes(status);
}
var DEFAULT_TRANSITION_POLICY = { allowCancelSubmitted: true };
function isAllowedFrom(state, rule) {
  if (!rule.from.includes(state.status)) return false;
  return !rule.requiresPayment || rule.requiresPayment === state.paymentStatus;
}
function cancelBlocked(state, action, policy) {
  return action === "CANCEL" && state.status === S.UNDER_REVIEW && !policy.allowCancelSubmitted;
}
function checkTransition(current, action, comment, policy = DEFAULT_TRANSITION_POLICY) {
  const rule = TRANSITIONS[action];
  if (!rule || !isAllowedFrom(current, rule)) {
    return { ok: false, error: "INVALID_TRANSITION" };
  }
  if (cancelBlocked(current, action, policy)) {
    return { ok: false, error: "CANCEL_NOT_ALLOWED" };
  }
  if (rule.requiresComment && !(comment && comment.trim().length >= 3)) {
    return { ok: false, error: "COMMENT_REQUIRED" };
  }
  return { ok: true, to: rule.to, toPayment: rule.toPayment ?? current.paymentStatus };
}
function availableActions(state, actor, policy = DEFAULT_TRANSITION_POLICY) {
  return Object.keys(TRANSITIONS).filter((action) => {
    const rule = TRANSITIONS[action];
    if (!isAllowedFrom(state, rule)) return false;
    if (cancelBlocked(state, action, policy)) return false;
    switch (rule.actor) {
      case "OWNER":
        return actor.isOwner;
      case "REVIEWER":
        return actor.canReview && !actor.isOwner;
      case "PAYER":
        return actor.canPay && !actor.isOwner;
      case "ADMIN":
        return actor.canReopen && !actor.isOwner;
      default:
        return false;
    }
  });
}
function actorRelationFor(action) {
  return TRANSITIONS[action].actor;
}

// src/domain/money.ts
var MAX_AMOUNT_CENTS = 1e10;
function assertCents(value) {
  if (!Number.isSafeInteger(value)) {
    throw new RangeError(`Valor monet\xE1rio inv\xE1lido (esperado inteiro em centavos): ${value}`);
  }
}
function parseMoneyToCents(input) {
  if (input === null || input === void 0) return null;
  if (typeof input === "number") {
    if (!Number.isFinite(input)) return null;
    return parseMoneyToCents(input.toFixed(2));
  }
  let s = input.trim().replace(/^R\$\s*/i, "").replace(/\s/g, "");
  if (!s) return null;
  let negative = false;
  if (s.startsWith("-")) {
    negative = true;
    s = s.slice(1);
  }
  const lastComma = s.lastIndexOf(",");
  const lastDot = s.lastIndexOf(".");
  let intPart;
  let fracPart = "";
  if (lastComma === -1 && lastDot === -1) {
    intPart = s;
  } else {
    const sepIndex = Math.max(lastComma, lastDot);
    const after = s.slice(sepIndex + 1);
    if (after.length >= 1 && after.length <= 2) {
      intPart = s.slice(0, sepIndex);
      fracPart = after;
    } else {
      intPart = s;
    }
    if (/[.,]/.test(intPart)) {
      const groups = intPart.split(/[.,]/);
      const valid = /^\d{1,3}$/.test(groups[0]) && groups.slice(1).every((g) => /^\d{3}$/.test(g));
      if (!valid) return null;
    }
    intPart = intPart.replace(/[.,]/g, "");
  }
  if (!/^\d+$/.test(intPart || "0") || fracPart && !/^\d{1,2}$/.test(fracPart)) return null;
  const cents = Number(intPart || "0") * 100 + Number(fracPart.padEnd(2, "0") || "0");
  if (!Number.isSafeInteger(cents) || cents > MAX_AMOUNT_CENTS) return null;
  return negative ? -cents : cents;
}
function formatCentsPlain(cents) {
  const negative = cents < 0;
  const abs = Math.abs(cents);
  const reais = String(Math.trunc(abs / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const centavos = String(abs % 100).padStart(2, "0");
  return `${negative ? "-" : ""}${reais},${centavos}`;
}
function formatCents(cents) {
  if (cents === null || cents === void 0) return "\u2014";
  const plain = formatCentsPlain(Math.abs(cents));
  return `${cents < 0 ? "-" : ""}R$ ${plain}`;
}
function divRoundHalfUp(numerator, denominator) {
  if (denominator <= 0n) throw new RangeError("Denominador deve ser positivo");
  const negative = numerator < 0n;
  const abs = negative ? -numerator : numerator;
  const q = (abs * 2n + denominator) / (denominator * 2n);
  return negative ? -q : q;
}
var BPS_ONE = 1e4;
function computeOvertimeAmountCents(params) {
  const { durationMinutes, hourlyRateCents, multiplierBps } = params;
  assertCents(hourlyRateCents);
  if (!Number.isSafeInteger(durationMinutes) || durationMinutes < 0) {
    throw new RangeError("Dura\xE7\xE3o inv\xE1lida");
  }
  if (!Number.isSafeInteger(multiplierBps) || multiplierBps < 0) {
    throw new RangeError("Multiplicador inv\xE1lido");
  }
  const numerator = BigInt(durationMinutes) * BigInt(hourlyRateCents) * BigInt(multiplierBps);
  const denominator = 60n * BigInt(BPS_ONE);
  return Number(divRoundHalfUp(numerator, denominator));
}
function formatMultiplier(bps) {
  const whole = Math.trunc(bps / BPS_ONE);
  const frac = String(bps % BPS_ONE).padStart(4, "0").replace(/0+$/, "");
  return `${whole}${frac ? `,${frac}` : ""}x`;
}

// src/domain/time.ts
import { DateTime } from "luxon";
var ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;
var TIME_HHMM_REGEX = /^([01]\d|2[0-3]):[0-5]\d$/;
function timeToMinutes(time) {
  if (time === "24:00") return 1440;
  if (!TIME_HHMM_REGEX.test(time)) throw new RangeError(`Hor\xE1rio inv\xE1lido: ${time}`);
  const [h, m] = time.split(":").map(Number);
  return h * 60 + m;
}
function minutesToTime(minutes) {
  if (!Number.isInteger(minutes) || minutes < 0 || minutes > 1440) {
    throw new RangeError(`Minutos inv\xE1lidos: ${minutes}`);
  }
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}
function formatDuration(minutes) {
  if (minutes === null || minutes === void 0) return "\u2014";
  const sign = minutes < 0 ? "-" : "";
  const abs = Math.abs(minutes);
  const h = Math.floor(abs / 60);
  const m = abs % 60;
  if (h === 0) return `${sign}${m}min`;
  if (m === 0) return `${sign}${h}h`;
  return `${sign}${h}h ${String(m).padStart(2, "0")}min`;
}
function formatDurationClock(minutes) {
  const sign = minutes < 0 ? "-" : "";
  const abs = Math.abs(minutes);
  return `${sign}${String(Math.floor(abs / 60)).padStart(2, "0")}:${String(abs % 60).padStart(2, "0")}`;
}
function toDateTime(value, zone = DEFAULT_TIMEZONE) {
  const dt = value instanceof Date ? DateTime.fromJSDate(value, { zone }) : DateTime.fromISO(value, { zone, setZone: false });
  return dt.setZone(zone);
}
function localDateTimeToIso(date, time, zone = DEFAULT_TIMEZONE) {
  if (!ISO_DATE_REGEX.test(date) || !TIME_HHMM_REGEX.test(time)) return null;
  const [year, month, day] = date.split("-").map(Number);
  const [hour, minute] = time.split(":").map(Number);
  const dt = DateTime.fromObject({ year, month, day, hour, minute }, { zone });
  if (!dt.isValid || dt.hour !== hour || dt.minute !== minute || dt.day !== day) return null;
  return dt.toUTC().toISO({ suppressMilliseconds: true });
}
function isoToLocalParts(iso, zone = DEFAULT_TIMEZONE) {
  const dt = toDateTime(iso, zone);
  return { date: dt.toFormat("yyyy-LL-dd"), time: dt.toFormat("HH:mm") };
}
function formatDateTime(iso, zone = DEFAULT_TIMEZONE) {
  if (!iso) return "\u2014";
  return toDateTime(iso, zone).toFormat("dd/LL/yyyy HH:mm");
}
function formatDate(value, zone = DEFAULT_TIMEZONE) {
  if (!value) return "\u2014";
  if (typeof value === "string" && ISO_DATE_REGEX.test(value)) {
    const [y, m, d] = value.split("-");
    return `${d}/${m}/${y}`;
  }
  return toDateTime(value, zone).toFormat("dd/LL/yyyy");
}
function todayIso(zone = DEFAULT_TIMEZONE, now = /* @__PURE__ */ new Date()) {
  return DateTime.fromJSDate(now, { zone }).toFormat("yyyy-LL-dd");
}
var WEEKDAY_LABELS = {
  1: "Segunda-feira",
  2: "Ter\xE7a-feira",
  3: "Quarta-feira",
  4: "Quinta-feira",
  5: "Sexta-feira",
  6: "S\xE1bado",
  7: "Domingo"
};
var WEEKDAY_SHORT_LABELS = {
  1: "Seg",
  2: "Ter",
  3: "Qua",
  4: "Qui",
  5: "Sex",
  6: "S\xE1b",
  7: "Dom"
};
function formatWeekday(value, zone = DEFAULT_TIMEZONE) {
  if (!value) return "\u2014";
  const dt = typeof value === "string" && ISO_DATE_REGEX.test(value) ? DateTime.fromISO(value, { zone }) : toDateTime(value, zone);
  return WEEKDAY_SHORT_LABELS[dt.weekday];
}

// src/domain/overtime-validation.ts
import { DateTime as DateTime2, Interval } from "luxon";
var OvertimeValidationCode = {
  INVALID_INTERVAL: "INVALID_INTERVAL",
  END_NOT_AFTER_START: "END_NOT_AFTER_START",
  DURATION_EXCEEDS_LIMIT: "DURATION_EXCEEDS_LIMIT",
  RETROACTIVE_LIMIT_EXCEEDED: "RETROACTIVE_LIMIT_EXCEEDED",
  FUTURE_NOT_ALLOWED: "FUTURE_NOT_ALLOWED",
  NO_WORK_SCHEDULE: "NO_WORK_SCHEDULE",
  SCHEDULE_CONFLICT: "SCHEDULE_CONFLICT",
  OVERLAPPING_REQUEST: "OVERLAPPING_REQUEST",
  DAILY_LIMIT_EXCEEDED: "DAILY_LIMIT_EXCEEDED",
  MONTHLY_LIMIT_EXCEEDED: "MONTHLY_LIMIT_EXCEEDED"
};
function toInstant(value) {
  return value instanceof Date ? DateTime2.fromJSDate(value) : DateTime2.fromISO(value);
}
function versionFor(versions, date) {
  return [...versions].sort((a, b) => b.validFrom.localeCompare(a.validFrom)).find((v) => v.validFrom <= date && (!v.validTo || v.validTo >= date));
}
function periodInterval(date, period, zone) {
  const base = DateTime2.fromObject({ year: date.year, month: date.month, day: date.day }, { zone });
  const at = (dayOffset, minutes) => DateTime2.fromObject(
    {
      year: base.year,
      month: base.month,
      day: base.day,
      hour: Math.floor(minutes / 60),
      minute: minutes % 60
    },
    { zone }
  ).plus({ days: dayOffset });
  const start = at(0, period.startMinute);
  const end = period.endMinute === 1440 ? at(1, 0) : period.endMinute <= period.startMinute ? at(1, period.endMinute) : at(0, period.endMinute);
  return Interval.fromDateTimes(start, end);
}
function validateOvertimeAgainstWorkSchedule(input) {
  const companyZone = input.timezone || DEFAULT_TIMEZONE;
  const versions = Array.isArray(input.employeeSchedule) ? input.employeeSchedule : [input.employeeSchedule];
  const holidaySet = new Set((input.holidays ?? []).map((h) => h.date));
  const start = toInstant(input.startAt);
  const end = toInstant(input.endAt);
  const result = {
    valid: false,
    errors: [],
    conflicts: [],
    durationMinutes: 0,
    startsOnNonWorkingDay: false,
    scheduleVersionIds: [],
    holidaysConsidered: []
  };
  if (!start.isValid || !end.isValid) {
    result.errors.push({
      code: OvertimeValidationCode.INVALID_INTERVAL,
      message: "Data/hora de in\xEDcio ou t\xE9rmino inv\xE1lida."
    });
    return result;
  }
  const durationMinutes = Math.round(end.diff(start, "minutes").minutes);
  result.durationMinutes = durationMinutes;
  if (end <= start || durationMinutes <= 0) {
    result.errors.push({
      code: OvertimeValidationCode.END_NOT_AFTER_START,
      message: "A data/hora de t\xE9rmino deve ser posterior \xE0 data/hora de in\xEDcio."
    });
    return result;
  }
  const request = Interval.fromDateTimes(start, end);
  const startLocal = start.setZone(companyZone);
  const endLocal = end.setZone(companyZone);
  const firstDay = startLocal.startOf("day").minus({ days: 1 });
  const lastDay = endLocal.minus({ milliseconds: 1 }).startOf("day");
  const usedVersions = /* @__PURE__ */ new Set();
  const missingDates = [];
  for (let day = firstDay; day <= lastDay; day = day.plus({ days: 1 })) {
    const date = day.toFormat("yyyy-LL-dd");
    const isRequestDay = day >= startLocal.startOf("day");
    const version = versionFor(versions, date);
    if (!version) {
      if (isRequestDay) missingDates.push(date);
      continue;
    }
    if (version.id) usedVersions.add(version.id);
    const zone = version.timezone || companyZone;
    const localDay = DateTime2.fromObject(
      { year: day.year, month: day.month, day: day.day },
      { zone }
    );
    const isHoliday = holidaySet.has(date);
    const periods = version.periods.filter((p) => p.weekday === localDay.weekday);
    if (date === startLocal.toFormat("yyyy-LL-dd")) {
      result.startsOnNonWorkingDay = isHoliday || periods.length === 0;
    }
    if (isHoliday) {
      if (isRequestDay) result.holidaysConsidered.push(date);
      continue;
    }
    for (const period of periods) {
      const work = periodInterval(localDay, period, zone);
      if (work.overlaps(request)) {
        result.conflicts.push({
          date,
          weekday: localDay.weekday,
          periodStart: minutesToTime(period.startMinute),
          periodEnd: minutesToTime(period.endMinute),
          periodStartAt: work.start.toUTC().toISO(),
          periodEndAt: work.end.toUTC().toISO(),
          message: `Conflito com a jornada de ${WEEKDAY_LABELS[localDay.weekday].toLowerCase()} (${day.toFormat(
            "dd/LL"
          )}) das ${minutesToTime(period.startMinute)} \xE0s ${minutesToTime(period.endMinute)}.`
        });
      }
    }
  }
  result.scheduleVersionIds = [...usedVersions];
  if (missingDates.length > 0) {
    result.errors.push({
      code: OvertimeValidationCode.NO_WORK_SCHEDULE,
      message: "N\xE3o h\xE1 jornada de trabalho configurada para o per\xEDodo informado. Procure o RH ou o administrador.",
      details: { dates: missingDates }
    });
  }
  if (result.conflicts.length > 0) {
    result.errors.push({
      code: OvertimeValidationCode.SCHEDULE_CONFLICT,
      message: "O per\xEDodo informado coincide com a sua jornada normal de trabalho. A hora extra deve estar totalmente fora da jornada.",
      details: { conflicts: result.conflicts }
    });
  }
  result.valid = result.errors.length === 0;
  return result;
}
var DEFAULT_OVERTIME_POLICY = {
  maxDurationMinutes: 12 * 60,
  retroactiveLimitDays: 30,
  allowFuture: false,
  maxMinutesPerDay: null,
  maxMinutesPerMonth: null
};
function validateOvertimeRequest(input) {
  const policy = { ...DEFAULT_OVERTIME_POLICY, ...input.policy ?? {} };
  const zone = input.timezone || DEFAULT_TIMEZONE;
  const result = validateOvertimeAgainstWorkSchedule(input);
  const hasBasicError = result.errors.some(
    (e) => e.code === OvertimeValidationCode.INVALID_INTERVAL || e.code === OvertimeValidationCode.END_NOT_AFTER_START
  );
  if (hasBasicError) return result;
  const start = toInstant(input.startAt);
  const end = toInstant(input.endAt);
  const now = DateTime2.fromJSDate(input.now ?? /* @__PURE__ */ new Date());
  if (result.durationMinutes > policy.maxDurationMinutes) {
    result.errors.push({
      code: OvertimeValidationCode.DURATION_EXCEEDS_LIMIT,
      message: `A dura\xE7\xE3o m\xE1xima de uma solicita\xE7\xE3o \xE9 de ${Math.floor(policy.maxDurationMinutes / 60)}h${policy.maxDurationMinutes % 60 ? ` ${policy.maxDurationMinutes % 60}min` : ""}.`,
      details: { maxDurationMinutes: policy.maxDurationMinutes }
    });
  }
  if (policy.retroactiveLimitDays !== null) {
    const limit = now.setZone(zone).startOf("day").minus({ days: policy.retroactiveLimitDays });
    if (start < limit) {
      result.errors.push({
        code: OvertimeValidationCode.RETROACTIVE_LIMIT_EXCEEDED,
        message: `N\xE3o \xE9 permitido registrar horas extras com mais de ${policy.retroactiveLimitDays} dias de anteced\xEAncia.`,
        details: { retroactiveLimitDays: policy.retroactiveLimitDays }
      });
    }
  }
  if (!policy.allowFuture && end > now.plus({ minutes: 5 })) {
    result.errors.push({
      code: OvertimeValidationCode.FUTURE_NOT_ALLOWED,
      message: "N\xE3o \xE9 permitido registrar horas extras que ainda n\xE3o terminaram."
    });
  }
  const others = (input.existing ?? []).filter((e) => e.id !== input.selfId);
  const request = Interval.fromDateTimes(start, end);
  const overlapping = others.filter(
    (e) => Interval.fromDateTimes(toInstant(e.startAt), toInstant(e.endAt)).overlaps(request)
  );
  if (overlapping.length > 0) {
    result.errors.push({
      code: OvertimeValidationCode.OVERLAPPING_REQUEST,
      message: "J\xE1 existe outra hora extra enviada que se sobrep\xF5e a este per\xEDodo.",
      details: { overlapping: overlapping.map((o) => ({ id: o.id, code: o.code })) }
    });
  }
  const startLocal = start.setZone(zone);
  const minutesOf = (e) => e.durationMinutes ?? Math.round(toInstant(e.endAt).diff(toInstant(e.startAt), "minutes").minutes);
  if (policy.maxMinutesPerDay !== null) {
    const day = startLocal.toFormat("yyyy-LL-dd");
    const used = others.filter((e) => toInstant(e.startAt).setZone(zone).toFormat("yyyy-LL-dd") === day).reduce((sum, e) => sum + minutesOf(e), 0);
    if (used + result.durationMinutes > policy.maxMinutesPerDay) {
      result.errors.push({
        code: OvertimeValidationCode.DAILY_LIMIT_EXCEEDED,
        message: `O limite di\xE1rio de horas extras (${policy.maxMinutesPerDay} minutos) seria excedido.`,
        details: { usedMinutes: used, maxMinutesPerDay: policy.maxMinutesPerDay }
      });
    }
  }
  if (policy.maxMinutesPerMonth !== null) {
    const month = startLocal.toFormat("yyyy-LL");
    const used = others.filter((e) => toInstant(e.startAt).setZone(zone).toFormat("yyyy-LL") === month).reduce((sum, e) => sum + minutesOf(e), 0);
    if (used + result.durationMinutes > policy.maxMinutesPerMonth) {
      result.errors.push({
        code: OvertimeValidationCode.MONTHLY_LIMIT_EXCEEDED,
        message: `O limite mensal de horas extras (${policy.maxMinutesPerMonth} minutos) seria excedido.`,
        details: { usedMinutes: used, maxMinutesPerMonth: policy.maxMinutesPerMonth }
      });
    }
  }
  result.valid = result.errors.length === 0;
  return result;
}

// src/schemas/common.ts
import { z } from "zod";
var uuidSchema = z.uuid("Identificador inv\xE1lido.");
var isoDateSchema = z.string().regex(ISO_DATE_REGEX, "Data inv\xE1lida (use AAAA-MM-DD).").refine((v) => !Number.isNaN(Date.parse(`${v}T00:00:00Z`)), "Data inv\xE1lida.");
var timeSchema = z.string().regex(TIME_HHMM_REGEX, "Hor\xE1rio inv\xE1lido (use HH:mm).");
var isoDateTimeSchema = z.iso.datetime({ offset: true, message: "Data/hora inv\xE1lida." });
var centsSchema = z.number({ message: "Valor inv\xE1lido." }).int("O valor deve estar em centavos (inteiro).").min(0, "O valor n\xE3o pode ser negativo.").max(1e10, "Valor acima do limite permitido.");
var positiveCentsSchema = centsSchema.refine(
  (v) => v > 0,
  "O valor deve ser maior que zero."
);
var trimmedString = (min, max, label) => z.string({ message: `${label} \xE9 obrigat\xF3rio.` }).trim().min(
  min,
  min <= 1 ? `${label} \xE9 obrigat\xF3rio.` : `${label} deve ter pelo menos ${min} caracteres.`
).max(max, `${label} deve ter no m\xE1ximo ${max} caracteres.`);
var optionalTrimmedString = (max, label) => z.string().trim().max(max, `${label} deve ter no m\xE1ximo ${max} caracteres.`).optional().nullable().transform((v) => v ? v : null);
var paginationSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(20)
});
var emailSchema = z.string({ message: "E-mail \xE9 obrigat\xF3rio." }).trim().toLowerCase().pipe(z.email("E-mail inv\xE1lido.").max(254));
var csvEnumSchema = (values) => z.union([z.string(), z.array(z.string())]).optional().transform((v) => {
  if (v === void 0) return void 0;
  const arr = (Array.isArray(v) ? v : v.split(",")).map((s) => s.trim()).filter(Boolean);
  return arr.length ? arr : void 0;
}).pipe(z.array(z.enum(values)).optional());

// src/schemas/auth.ts
import { z as z2 } from "zod";
var PASSWORD_MIN_LENGTH = 10;
var passwordSchema = z2.string({ message: "Senha \xE9 obrigat\xF3ria." }).min(PASSWORD_MIN_LENGTH, `A senha deve ter pelo menos ${PASSWORD_MIN_LENGTH} caracteres.`).max(128, "A senha deve ter no m\xE1ximo 128 caracteres.").refine((v) => /[A-Za-z]/.test(v) && /\d/.test(v), "A senha deve conter letras e n\xFAmeros.");
var loginSchema = z2.object({
  email: emailSchema,
  password: z2.string().min(1, "Senha \xE9 obrigat\xF3ria.").max(128),
  /** Identificação amigável do dispositivo/sessão (ex.: "iPhone de Ana"). */
  deviceName: z2.string().trim().max(100).optional(),
  platform: z2.enum([DevicePlatform.IOS, DevicePlatform.ANDROID, DevicePlatform.WEB]).optional()
});
var refreshSchema = z2.object({
  /** Apenas clientes mobile enviam o refresh token no corpo; a web usa cookie httpOnly. */
  refreshToken: z2.string().min(20).max(512).optional()
});
var forgotPasswordSchema = z2.object({ email: emailSchema });
var resetPasswordSchema = z2.object({
  token: z2.string().min(20).max(512),
  password: passwordSchema,
  passwordConfirmation: z2.string()
}).refine((v) => v.password === v.passwordConfirmation, {
  message: "As senhas n\xE3o conferem.",
  path: ["passwordConfirmation"]
});
var changePasswordSchema = z2.object({
  currentPassword: z2.string().min(1, "Informe a senha atual.").max(128),
  newPassword: passwordSchema,
  newPasswordConfirmation: z2.string()
}).refine((v) => v.newPassword === v.newPasswordConfirmation, {
  message: "As senhas n\xE3o conferem.",
  path: ["newPasswordConfirmation"]
}).refine((v) => v.newPassword !== v.currentPassword, {
  message: "A nova senha deve ser diferente da atual.",
  path: ["newPassword"]
});
var registerDeviceSchema = z2.object({
  platform: z2.enum([DevicePlatform.IOS, DevicePlatform.ANDROID, DevicePlatform.WEB]),
  deviceId: z2.string().trim().min(1).max(200),
  pushToken: z2.string().trim().min(1).max(500),
  deviceName: z2.string().trim().max(100).optional()
});

// src/schemas/users.ts
import { z as z3 } from "zod";
var roleEnum = z3.enum([RoleCode.ADMIN, RoleCode.HR, RoleCode.EMPLOYEE], {
  message: "Perfil inv\xE1lido."
});
var timezoneSchema = z3.string().trim().min(1).max(64).refine((tz) => {
  try {
    new Intl.DateTimeFormat("en-US", { timeZone: tz });
    return true;
  } catch {
    return false;
  }
}, "Fuso hor\xE1rio inv\xE1lido.");
var employeeDataSchema = z3.object({
  registration: optionalTrimmedString(40, "Matr\xEDcula"),
  position: optionalTrimmedString(120, "Cargo"),
  departmentId: uuidSchema.optional().nullable(),
  costCenterId: uuidSchema.optional().nullable(),
  hireDate: isoDateSchema.optional().nullable(),
  timezone: timezoneSchema.default(DEFAULT_TIMEZONE),
  /** Valor da hora (centavos) para cálculo estimado de horas extras. */
  hourlyRateCents: centsSchema.optional().nullable(),
  /** Multiplicador próprio (basis points). `null` = usa o padrão do sistema. */
  overtimeMultiplierBps: z3.number().int().min(1e4).max(5e4).optional().nullable()
});
var createUserSchema = z3.object({
  name: trimmedString(3, 150, "Nome"),
  email: emailSchema,
  role: roleEnum,
  /** Envia e-mail de convite para o usuário definir a própria senha. */
  sendInvite: z3.boolean().default(true),
  /** Dados de funcionário. Obrigatório para o perfil Funcionário; opcional para RH/Admin. */
  employee: employeeDataSchema.optional().nullable()
}).refine((v) => v.role !== RoleCode.EMPLOYEE || !!v.employee, {
  message: "Os dados de funcion\xE1rio s\xE3o obrigat\xF3rios para o perfil Funcion\xE1rio.",
  path: ["employee"]
});
var updateUserSchema = z3.object({
  name: trimmedString(3, 150, "Nome").optional(),
  email: emailSchema.optional(),
  role: roleEnum.optional()
});
var userStatusChangeSchema = z3.object({
  reason: optionalTrimmedString(500, "Motivo")
});
var listUsersQuerySchema = paginationSchema.extend({
  search: z3.string().trim().max(100).optional(),
  role: csvEnumSchema([RoleCode.ADMIN, RoleCode.HR, RoleCode.EMPLOYEE]),
  status: csvEnumSchema([
    UserStatus.PENDING_ACTIVATION,
    UserStatus.ACTIVE,
    UserStatus.BLOCKED,
    UserStatus.INACTIVE
  ]),
  departmentId: uuidSchema.optional()
});
var updateEmployeeSchema = employeeDataSchema.partial();
var scheduleTimeSchema = z3.string().refine((v) => v === "24:00" || TIME_HHMM_REGEX.test(v), "Hor\xE1rio inv\xE1lido (use HH:mm).");
var schedulePeriodInputSchema = z3.object({
  weekday: z3.number().int().min(1, "Dia da semana inv\xE1lido.").max(7, "Dia da semana inv\xE1lido."),
  start: scheduleTimeSchema,
  end: scheduleTimeSchema
}).refine((p) => p.start !== "24:00", { message: "In\xEDcio inv\xE1lido.", path: ["start"] }).refine((p) => p.start !== p.end, {
  message: "In\xEDcio e fim n\xE3o podem ser iguais.",
  path: ["end"]
});
function periodWeekRange(p) {
  const start = timeToMinutes(p.start);
  let end = timeToMinutes(p.end);
  if (end <= start) end += 1440;
  const offset = (p.weekday - 1) * 1440;
  return [offset + start, offset + end];
}
var createWorkScheduleSchema = z3.object({
  name: optionalTrimmedString(100, "Nome"),
  timezone: timezoneSchema.default(DEFAULT_TIMEZONE),
  validFrom: isoDateSchema,
  periods: z3.array(schedulePeriodInputSchema).max(28, "Per\xEDodos demais."),
  notes: optionalTrimmedString(500, "Observa\xE7\xE3o")
}).superRefine((v, ctx) => {
  const ranges = v.periods.map(periodWeekRange);
  const WEEK = 7 * 1440;
  for (let i = 0; i < ranges.length; i++) {
    for (let j = i + 1; j < ranges.length; j++) {
      const [a1, a2] = ranges[i];
      const [b1, b2] = ranges[j];
      const overlaps = (x1, x2, y1, y2) => x1 < y2 && y1 < x2;
      if (overlaps(a1, a2, b1, b2) || overlaps(a1 + WEEK, a2 + WEEK, b1, b2) || overlaps(a1, a2, b1 + WEEK, b2 + WEEK)) {
        ctx.addIssue({
          code: "custom",
          message: "Existem per\xEDodos de trabalho sobrepostos.",
          path: ["periods", j]
        });
      }
    }
  }
});
var updateWorkScheduleSchema = z3.object({
  name: optionalTrimmedString(100, "Nome"),
  notes: optionalTrimmedString(500, "Observa\xE7\xE3o"),
  /** Encerrar a vigência (a jornada deixa de valer após esta data). */
  validTo: isoDateSchema.optional().nullable()
});
var holidaySchema = z3.object({
  date: isoDateSchema,
  name: trimmedString(2, 120, "Nome"),
  kind: z3.enum([HolidayKind.HOLIDAY, HolidayKind.DAY_OFF]).default(HolidayKind.HOLIDAY),
  /** Folga individual: informe o funcionário. Feriado: deixe vazio (vale para todos). */
  employeeId: uuidSchema.optional().nullable()
});
var importHolidaysSchema = z3.object({
  holidays: z3.array(holidaySchema).min(1).max(500)
});
var listHolidaysQuerySchema = z3.object({
  from: isoDateSchema.optional(),
  to: isoDateSchema.optional(),
  employeeId: uuidSchema.optional()
});
var departmentSchema = z3.object({
  name: trimmedString(2, 100, "Nome"),
  active: z3.boolean().default(true)
});
var costCenterSchema = z3.object({
  code: trimmedString(1, 30, "C\xF3digo"),
  name: trimmedString(2, 120, "Nome"),
  active: z3.boolean().default(true)
});
var reimbursementCategorySchema = z3.object({
  name: trimmedString(2, 80, "Nome"),
  description: optionalTrimmedString(300, "Descri\xE7\xE3o"),
  /** Valor máximo por solicitação nesta categoria (centavos). */
  maxAmountCents: centsSchema.optional().nullable(),
  active: z3.boolean().default(true)
});

// src/schemas/requests.ts
import { z as z4 } from "zod";
var ALL_STATUSES = Object.values(RequestStatus);
var ALL_PAYMENT_STATUSES = Object.values(PaymentStatus);
var LEGACY_STATUS = {
  SUBMITTED: RequestStatus.UNDER_REVIEW,
  PAID: RequestStatus.APPROVED
};
var statusFilterSchema = z4.preprocess((v) => {
  if (typeof v !== "string" && !Array.isArray(v)) return v;
  const values = (Array.isArray(v) ? v : v.split(",")).map((s) => {
    const trimmed = String(s).trim();
    return LEGACY_STATUS[trimmed] ?? trimmed;
  });
  return [...new Set(values)];
}, csvEnumSchema(ALL_STATUSES));
var overtimeBaseSchema = z4.object({
  startAt: isoDateTimeSchema,
  endAt: isoDateTimeSchema,
  reason: trimmedString(10, 2e3, "Motivo"),
  notes: optionalTrimmedString(2e3, "Observa\xE7\xE3o"),
  costCenterId: uuidSchema.optional().nullable(),
  projectOrClient: optionalTrimmedString(150, "Projeto/cliente")
});
var endAfterStart = (v) => !v.startAt || !v.endAt || Date.parse(v.endAt) > Date.parse(v.startAt);
var createOvertimeSchema = overtimeBaseSchema.extend({
  /** Envia imediatamente após criar (sem passar por rascunho). */
  submit: z4.boolean().default(false)
}).refine(endAfterStart, {
  message: "A data/hora de t\xE9rmino deve ser posterior \xE0 de in\xEDcio.",
  path: ["endAt"]
});
var updateOvertimeSchema = overtimeBaseSchema.partial().refine(endAfterStart, {
  message: "A data/hora de t\xE9rmino deve ser posterior \xE0 de in\xEDcio.",
  path: ["endAt"]
});
var validateOvertimeSchema = z4.object({
  startAt: isoDateTimeSchema,
  endAt: isoDateTimeSchema,
  /** Ao editar, informe o id para ignorar a própria solicitação na checagem de sobreposição. */
  requestId: uuidSchema.optional()
});
var reimbursementBaseSchema = z4.object({
  expenseDate: isoDateSchema,
  categoryId: uuidSchema,
  amountCents: positiveCentsSchema,
  description: trimmedString(3, 200, "Descri\xE7\xE3o"),
  justification: trimmedString(10, 2e3, "Justificativa"),
  costCenterId: uuidSchema.optional().nullable(),
  projectOrClient: optionalTrimmedString(150, "Projeto/cliente"),
  paymentMethod: z4.enum(Object.values(PaymentMethod)).optional().nullable()
});
var createReimbursementSchema = reimbursementBaseSchema;
var updateReimbursementSchema = reimbursementBaseSchema.partial();
var submitRequestSchema = z4.object({
  comment: optionalTrimmedString(1e3, "Coment\xE1rio")
});
var approveRequestSchema = z4.object({
  comment: optionalTrimmedString(1e3, "Coment\xE1rio"),
  /** Valor aprovado (centavos). Se diferente do solicitado/estimado, a justificativa é obrigatória. */
  approvedAmountCents: centsSchema.optional().nullable(),
  amountJustification: optionalTrimmedString(1e3, "Justificativa do valor")
});
var reasonSchema = z4.object({
  reason: trimmedString(3, 1e3, "Motivo")
});
var markPaidSchema = z4.object({
  paidAt: isoDateSchema,
  reference: optionalTrimmedString(120, "Refer\xEAncia"),
  notes: optionalTrimmedString(1e3, "Observa\xE7\xE3o")
});
var bulkMarkPaidSchema = markPaidSchema.extend({
  items: z4.array(
    z4.object({
      type: z4.enum([RequestType.OVERTIME, RequestType.REIMBURSEMENT]),
      id: uuidSchema
    })
  ).min(1, "Selecione ao menos uma solicita\xE7\xE3o.").max(100, "Selecione no m\xE1ximo 100 solicita\xE7\xF5es por vez.")
});
var commentSchema = z4.object({
  body: trimmedString(1, 2e3, "Coment\xE1rio"),
  /** Nota interna (somente RH/Admin). */
  internal: z4.boolean().default(false)
});
var listMyRequestsQuerySchema = paginationSchema.extend({
  status: statusFilterSchema,
  /** Status de pagamento (considera apenas solicitações aprovadas). */
  paymentStatus: csvEnumSchema(ALL_PAYMENT_STATUSES),
  from: isoDateSchema.optional(),
  to: isoDateSchema.optional()
});
var REQUEST_SORT_FIELDS = [
  "date",
  "createdAt",
  "submittedAt",
  "amount",
  "employee"
];
var rhRequestFiltersSchema = z4.object({
  /** Período da solicitação: data da despesa (reembolso) ou data de início (hora extra). */
  from: isoDateSchema.optional(),
  to: isoDateSchema.optional(),
  /** Período de pagamento. */
  paidFrom: isoDateSchema.optional(),
  paidTo: isoDateSchema.optional(),
  employeeId: uuidSchema.optional(),
  departmentId: uuidSchema.optional(),
  costCenterId: uuidSchema.optional(),
  type: csvEnumSchema([RequestType.OVERTIME, RequestType.REIMBURSEMENT]),
  categoryId: uuidSchema.optional(),
  status: statusFilterSchema,
  /** Status de pagamento (considera apenas solicitações aprovadas). */
  paymentStatus: csvEnumSchema(ALL_PAYMENT_STATUSES),
  minAmountCents: z4.coerce.number().int().min(0).optional(),
  maxAmountCents: z4.coerce.number().int().min(0).optional(),
  search: z4.string().trim().max(100).optional(),
  /** Apenas pendentes há mais de N dias (vencidas). */
  overdue: z4.enum(["true", "false"]).optional().transform((v) => v === "true")
});
var rhRequestListQuerySchema = rhRequestFiltersSchema.merge(paginationSchema).extend({
  sort: z4.enum(REQUEST_SORT_FIELDS).default("submittedAt"),
  order: z4.enum(["asc", "desc"]).default("desc")
});
var auditLogQuerySchema = paginationSchema.extend({
  actorId: uuidSchema.optional(),
  entityType: z4.string().trim().max(60).optional(),
  entityId: z4.string().trim().max(60).optional(),
  action: z4.string().trim().max(80).optional(),
  from: isoDateSchema.optional(),
  to: isoDateSchema.optional()
});

// src/schemas/settings.ts
import { z as z5 } from "zod";
var systemSettingsSchema = z5.object({
  companyName: z5.string().trim().min(2).max(120),
  timezone: timezoneSchema,
  currency: z5.literal("BRL"),
  overtime: z5.object({
    maxDurationMinutes: z5.number().int().min(15).max(24 * 60),
    retroactiveLimitDays: z5.number().int().min(0).max(365).nullable(),
    allowFuture: z5.boolean(),
    maxMinutesPerDay: z5.number().int().min(15).max(24 * 60).nullable(),
    maxMinutesPerMonth: z5.number().int().min(60).max(744 * 60).nullable(),
    /** Multiplicador padrão (basis points). 15000 = 1,5x (adicional de 50%). */
    defaultMultiplierBps: z5.number().int().min(1e4).max(5e4),
    /** Multiplicador para feriados, folgas e dias sem jornada. 20000 = 2,0x (adicional de 100%). */
    nonWorkingDayMultiplierBps: z5.number().int().min(1e4).max(5e4),
    requireAttachment: z5.boolean()
  }),
  reimbursement: z5.object({
    retroactiveLimitDays: z5.number().int().min(0).max(730).nullable(),
    maxAttachmentsPerRequest: z5.number().int().min(1).max(20)
  }),
  attachments: z5.object({
    maxFileSizeBytes: z5.number().int().min(100 * 1024).max(20 * 1024 * 1024),
    maxTotalSizeBytesPerRequest: z5.number().int().min(100 * 1024).max(50 * 1024 * 1024),
    retentionYears: z5.number().int().min(1).max(30)
  }),
  workflow: z5.object({
    allowCancelSubmitted: z5.boolean(),
    /** Permite ao funcionário criar uma nova solicitação a partir de uma recusada. */
    allowResubmitRejected: z5.boolean(),
    /** Solicitações pendentes há mais de N dias são consideradas vencidas. */
    overdueAfterDays: z5.number().int().min(1).max(90),
    /** Enviar lembrete diário ao RH sobre pendências vencidas. */
    hrReminderEnabled: z5.boolean()
  }),
  notifications: z5.object({
    /** E-mail que recebe alertas operacionais (além dos administradores). */
    opsAlertEmail: z5.email().nullable(),
    hrReplyToEmail: z5.email().nullable()
  })
});
var updateSystemSettingsSchema = z5.object({
  companyName: systemSettingsSchema.shape.companyName.optional(),
  timezone: systemSettingsSchema.shape.timezone.optional(),
  overtime: systemSettingsSchema.shape.overtime.partial().optional(),
  reimbursement: systemSettingsSchema.shape.reimbursement.partial().optional(),
  attachments: systemSettingsSchema.shape.attachments.partial().optional(),
  workflow: systemSettingsSchema.shape.workflow.partial().optional(),
  notifications: systemSettingsSchema.shape.notifications.partial().optional()
});
var DEFAULT_SYSTEM_SETTINGS = {
  companyName: "i9vate",
  timezone: DEFAULT_TIMEZONE,
  currency: "BRL",
  overtime: {
    maxDurationMinutes: 12 * 60,
    retroactiveLimitDays: 30,
    allowFuture: false,
    maxMinutesPerDay: null,
    maxMinutesPerMonth: null,
    defaultMultiplierBps: 15e3,
    nonWorkingDayMultiplierBps: 2e4,
    requireAttachment: false
  },
  reimbursement: {
    retroactiveLimitDays: 90,
    maxAttachmentsPerRequest: 10
  },
  attachments: {
    maxFileSizeBytes: 10 * 1024 * 1024,
    maxTotalSizeBytesPerRequest: 25 * 1024 * 1024,
    retentionYears: 5
  },
  workflow: {
    allowCancelSubmitted: true,
    allowResubmitRejected: true,
    overdueAfterDays: 5,
    hrReminderEnabled: true
  },
  notifications: {
    opsAlertEmail: null,
    hrReplyToEmail: null
  }
};
var configurableTypes = CONFIGURABLE_NOTIFICATION_TYPES;
var notificationPreferencesSchema = z5.object({
  preferences: z5.array(
    z5.object({
      type: z5.enum(configurableTypes),
      email: z5.boolean(),
      push: z5.boolean()
    })
  ).max(50)
});

// src/api/request-code.ts
var PREFIX = { OVERTIME: "HE", REIMBURSEMENT: "RE" };
function formatRequestCode(type, number) {
  return `${PREFIX[type]}-${String(number).padStart(6, "0")}`;
}
function requestDeepLinkPath(type, id) {
  return type === "OVERTIME" ? `/horas-extras/${id}` : `/reembolsos/${id}`;
}
export {
  ALLOWED_ATTACHMENT_MIME_TYPES,
  ALL_PERMISSIONS,
  AttachmentScanStatus,
  BPS_ONE,
  CONFIGURABLE_NOTIFICATION_TYPES,
  CommentVisibility,
  DEFAULT_CURRENCY,
  DEFAULT_OVERTIME_POLICY,
  DEFAULT_SYSTEM_SETTINGS,
  DEFAULT_TIMEZONE,
  DEFAULT_TRANSITION_POLICY,
  DevicePlatform,
  EDITABLE_STATUSES,
  ErrorCode,
  HOLIDAY_KIND_LABELS,
  HolidayKind,
  ISO_DATE_REGEX,
  MAX_AMOUNT_CENTS,
  NOTIFICATION_TYPE_LABELS,
  NotificationType,
  OUTBOX_CHANNEL_LABELS,
  OUTBOX_STATUS_LABELS,
  OVERTIME_BLOCKING_STATUSES,
  OutboxChannel,
  OutboxStatus,
  OvertimeValidationCode,
  PASSWORD_MIN_LENGTH,
  PAYMENT_METHOD_LABELS,
  PAYMENT_STATUS_LABELS,
  PENDING_REVIEW_STATUSES,
  PERMISSION_DESCRIPTIONS,
  PaymentMethod,
  PaymentStatus,
  Permission,
  REQUEST_ACTION_LABELS,
  REQUEST_SORT_FIELDS,
  REQUEST_STATUS_LABELS,
  REQUEST_TYPE_LABELS,
  ROLE_LABELS,
  ROLE_PERMISSIONS,
  RequestAction,
  RequestStatus,
  RequestType,
  RoleCode,
  TIME_HHMM_REGEX,
  TRANSITIONS,
  USER_STATUS_LABELS,
  UserStatus,
  WEEKDAY_LABELS,
  WEEKDAY_SHORT_LABELS,
  actorRelationFor,
  approveRequestSchema,
  assertCents,
  auditLogQuerySchema,
  availableActions,
  bulkMarkPaidSchema,
  centsSchema,
  changePasswordSchema,
  checkTransition,
  commentSchema,
  computeOvertimeAmountCents,
  costCenterSchema,
  createOvertimeSchema,
  createReimbursementSchema,
  createUserSchema,
  createWorkScheduleSchema,
  csvEnumSchema,
  departmentSchema,
  divRoundHalfUp,
  emailSchema,
  employeeDataSchema,
  forgotPasswordSchema,
  formatCents,
  formatCentsPlain,
  formatDate,
  formatDateTime,
  formatDuration,
  formatDurationClock,
  formatMultiplier,
  formatRequestCode,
  formatWeekday,
  hasPermission,
  historyActionLabel,
  historyResultLabel,
  holidaySchema,
  importHolidaysSchema,
  isEditableStatus,
  isoDateSchema,
  isoDateTimeSchema,
  isoToLocalParts,
  listHolidaysQuerySchema,
  listMyRequestsQuerySchema,
  listUsersQuerySchema,
  localDateTimeToIso,
  loginSchema,
  markPaidSchema,
  minutesToTime,
  notificationPreferencesSchema,
  optionalTrimmedString,
  overtimeBaseSchema,
  paginationSchema,
  parseMoneyToCents,
  passwordSchema,
  positiveCentsSchema,
  reasonSchema,
  refreshSchema,
  registerDeviceSchema,
  reimbursementBaseSchema,
  reimbursementCategorySchema,
  requestDeepLinkPath,
  resetPasswordSchema,
  rhRequestFiltersSchema,
  rhRequestListQuerySchema,
  roleHasPermission,
  schedulePeriodInputSchema,
  submitRequestSchema,
  systemSettingsSchema,
  timeSchema,
  timeToMinutes,
  timezoneSchema,
  toDateTime,
  todayIso,
  trimmedString,
  updateEmployeeSchema,
  updateOvertimeSchema,
  updateReimbursementSchema,
  updateSystemSettingsSchema,
  updateUserSchema,
  updateWorkScheduleSchema,
  userStatusChangeSchema,
  uuidSchema,
  validateOvertimeAgainstWorkSchedule,
  validateOvertimeRequest,
  validateOvertimeSchema,
  visiblePaymentStatus
};
//# sourceMappingURL=index.mjs.map